<script>
import moment from "moment";
export default {
	props:{
		updateDatas:{
			type:Array,
			default:[]
		},
		showArrow:{
			type:Boolean,
			detault:false,
		}
	},
	data(){
		return {
			showItems:true
		}
	},
	mounted() {
		this.showItems = this.updateDatas.length > 0
	},
	methods:{
		moment,
	}
}
</script>

<template>
	<div class="newsUpdateDetail">
		<div class="top_row">
			<div class="title">
				<div style="display: flex;align-items: center;flex:auto">
					<div class="circle"></div>
					<div>{{ $t('key87xiudingjilu') }}</div>
				</div>
				<div v-if="updateDatas.length > 0" @click="showItems = !showItems">
					<a-icon type="caret-down" v-if="showArrow && showItems"/>
					<a-icon type="caret-up" v-if="showArrow && !showItems"/>
				</div>
			</div>
			
		</div>
		<div v-if="showItems" class="item_row" v-for="(item,index) in updateDatas">
			<div class="item_detail" v-for="(itemDetail,index) in item.amendmentContentDetail">
				<a-row :gutter="10" class="item_text">
					<a-col :span="4" class="name_text">
						{{ itemDetail.name }}：
					</a-col>
					<a-col :span="20">
						【 {{itemDetail.oldValue ? itemDetail.oldValue:'~'}} 】<span>{{ $t('key87xiudingwei') }}</span>【 {{itemDetail.newValue?itemDetail.newValue:'~'}} 】
					</a-col>
				</a-row>
			</div>
			<div class="item_bottom">
				<div>{{ $t('key87xiudingren') }} </div>
				<div style="margin-left: 5px;">{{item.amendmentUserName}}</div>
				<div class="time_div">{{moment(item.createTime).format("YYYY-MM-DD")}}</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="less">
.newsUpdateDetail{
	margin-top:20px;
	.top_row{
		background: #FAFBFC;
		border-radius: 4px;
		height: 40px;
	}
	.item_row{
		background: rgba(248,249,251,0.62);
		border-radius: 4px;
		padding: 14px 20px;
		margin-top: 5px;
		.item_detail{
			.item_text{
				font-size: 12px;
				color: #333333;
				margin-bottom: 15px;
				.name_text{
					text-align: left;
				}
			}
			
		}
		.item_bottom{
			font-size: 12px;
			color: #999999;
			display: flex;
			.time_div{
				margin-left: 20px;
			}
		}
	}
}
.circle{
	margin-right: 12px;
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: #FABE00;
	display: inline-block;
}
.title{
	font-size: 14px;
	color: #333333;
	font-weight: bold;
	height: 40px;
	padding: 0px 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

</style>